import * as axios from "axios";

export const searchWithDynamicQuery = async (params) => {
  try {
    const response = await axios.get(
      'https://d126xd59kaz5rr.cloudfront.net/api/proxy/oats/shell-lmc-ua/search',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw new Error('Failed to fetch data');
  }
};

export const getCarInformationbyId = async (href) => {
  let response = await axios.get(
    `https://d126xd59kaz5rr.cloudfront.net/api/proxy/oats/shell-lmc-ua${href}?language=uk`
  );
  return response.data;
};